module.exports = __webpack_public_path__ + "img/QR-5799.74f49006.png";